import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0.17 0.85 22.83 17.29",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.17972 0.854492C1.5161 0.854492 0.16748 2.20312 0.16748 3.86673V15.1325C0.16748 16.7961 1.51611 18.1447 3.17972 18.1447H14.4455C16.1091 18.1447 17.4577 16.7961 17.4577 15.1325V3.86673C17.4577 2.20312 16.1091 0.854492 14.4455 0.854492H3.17972ZM8.84281 15.0118C11.9039 15.0118 14.3853 12.5303 14.3853 9.46927C14.3853 6.40823 11.9039 3.92676 8.84281 3.92676C5.78176 3.92676 3.30029 6.40823 3.30029 9.46927C3.30029 12.5303 5.78176 15.0118 8.84281 15.0118ZM12.3365 9.46929C12.3365 11.3991 10.7721 12.9635 8.84234 12.9635C6.91255 12.9635 5.34814 11.3991 5.34814 9.46929C5.34814 7.5395 6.91255 5.9751 8.84234 5.9751C10.7721 5.9751 12.3365 7.5395 12.3365 9.46929ZM18.7833 4.25816C18.5635 4.35389 18.4215 4.57077 18.4215 4.81046V14.1286C18.4215 14.3683 18.5635 14.5852 18.7833 14.6809L22.157 16.1508C22.5549 16.3242 23.0001 16.0326 23.0001 15.5985V3.34053C23.0001 2.90647 22.5549 2.61485 22.157 2.78823L18.7833 4.25816Z",
		fill: "white"
	})
});
export default SvgVideo;
